import isBackOffice from 'utils/appUtils';

export const LOAD_APPRAISER_APPLICATION = 'LOAD_APPRAISER_APPLICATION';

export const LOAD_BO_APPLICATION_REQUEST = 'LOAD_BO_APPLICATION_REQUEST';
export const LOAD_BO_APPLICATION_SUCCESS = 'LOAD_BO_APPLICATION_SUCCESS';

export const loadApplicationRequest = () => ({
  type: isBackOffice ? LOAD_BO_APPLICATION_REQUEST : LOAD_APPRAISER_APPLICATION,
  payload: null,
});

export const loadBoApplicationSuccess = appData => ({
  type: LOAD_BO_APPLICATION_SUCCESS,
  payload: { ...appData },
});
